import {useNavigationStore} from '../../../../../../../../Stores/navigation';

import RecomendationDescriptionPreloader from '../../../../../../../../Components/RecomendationDescriptionPreloader'
import PreloaderText from '../../../../../../../../Components/Preloaders/PreloaderText';

import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import LocationWidget from '../../../../../../Widgets/LocationWidget'
import MessengerValue from '../../../../../../Widgets/MessengerValue'
import URLField from '../../../../../../Widgets/URLField'
import ContentImage from '../../../../../../Widgets/ContentImage'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import FilterChip from '../../../../../../Widgets/FilterChip'

import './index.scss';

export default function Template(props) {
    const {content, permits, config, breadcrumbs} = props

    const {contentLoading} = useNavigationStore()

    return <div className='URL'>
        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {contentLoading && <PreloaderText />}

        {!contentLoading && <>
            <ContentImage src="thumbnail" image={content.thumbnail} />

            {content.link && <p className='labelWrap labelWrapRow'>
                <span className="label">Посилання:</span>
                <span className="labelValue">
                    <a
                        href={content.link.link}
                        target="_blank"
                    >
                        {content.link.title || content.link.link}
                    </a>
                </span>
            </p>}

            <CKEditorContent content={content.description} />
        </>}
    </div>
}
